export default "__VITE_ASSET__BPu3Gcnr__"